import { waitForElement } from '../../../utils/index.js';
import { instacartConfig as config } from '../data/index.js';
/**
 * `instacartCheckout` is the {@link ICheckoutService} for
 * the Instacart retailer integration
 */
const instacartCheckout = {
    config,
    /**
     * `checkout` executes the instacart-specific functionality to purchase products
     * @param {IRetailerCartItem[]} items - the {@link IRetailerCartItem} array of products to be purchased
     * @param {IRetailerLocation} location - the currently selected {@link IRetailerLocation}
     */
    checkout: ( /* items: IRetailerCartItem[], location: IRetailerLocation */) => {
        console.log(`checkout via url params should be depreciated, use instacart api script instead`);
    }
};
const handleInstacartLoaded = async (event) => {
    const iframe = await waitForElement('.instacart-container iframe');
    iframe.style.borderRadius = '4px';
    iframe.style.backgroundColor = 'rgb(0, 61, 41)';
};
export const destroyService = () => {
    const instaScript = document.getElementById('standard-instacart-widget-v1');
    const instaSnippet = document.getElementById('instacart-snippet');
    if (instaScript)
        instaScript.remove();
    if (instaSnippet)
        instaSnippet.remove();
    window.removeEventListener('instacart-loaded', handleInstacartLoaded);
};
export const initService = () => {
    window.addEventListener('instacart-loaded', handleInstacartLoaded);
    attachScript();
};
const attachScript = () => {
    const script = document.createElement('script');
    script.id = 'instacart-snippet';
    script.innerText = `(function (w, d, s, id) {
        var js, fjs = d.getElementsByTagName(s)[0];
        console.log('instacart loaded');
        if (d.getElementById(id)) { return; }
        js = d.createElement(s);
        js.id = id;
        js.src = "https://widgets.instacart.com/widget-bundle.js";
        js.async = true;
        js.onload = () => {
            var event = new Event('instacart-loaded');
            w.dispatchEvent(event);
        };
        fjs.parentNode.insertBefore(js, fjs);
    })(window, document, "script", "standard-instacart-widget-v1");`;
    document.body.appendChild(script);
};
export default instacartCheckout;
